import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { FreeBetToken } from '../../../../reward-tokens/reward-tokens.model';
import { IStakeErrorViewModel } from '../../../../summary/models/stake-errors.model';
import { IStake } from '../../../models';

export interface ILinearContainerStakeService {
    getAdornmentText(): Observable<string | undefined>;
    getKeypadId(): string;
    setStake(stakeStr: string, stake: number | null): void;
    clickStake(stake: IStake | null): void;
    getStake$(): Observable<IStake | null>;
    getStakeErrors$(): Observable<IStakeErrorViewModel | null>;
    getFreeBetToken$(): Observable<FreeBetToken | null>;
}

export const LINEAR_CONTAINER_STAKE_SERVICE = new InjectionToken<ILinearContainerStakeService>('LINEAR_CONTAINER_STAKE_SERVICE');
